import {
  OverigeVerzekerdenModel,
  OverigInkomenModel,
  VerdragsbijdrageInputModel,
  WettelijkPensioenOfUitkeringModel
} from "@core/client";
import { DateFormatEnum, formatStringToDate } from "@core/utils";
import { getDateInUtc, stringToFloat } from "@opencak-btl-rekenmodules/shared";
import { JaNee } from "../enums/janee";
import { VBRekenModel } from "../service/vb-tool-service";

export const gezinsLid = (values: VBRekenModel, gezinsLid: number) => {
  if (
    values.datumMeeverzekeringGezinsledenSection &&
    gezinsLid <= values.datumMeeverzekeringGezinsledenSection.datumMeeverzekeringGezinsleden.length
  ) {
    return getDateInUtc(
      formatStringToDate(
        values.datumMeeverzekeringGezinsledenSection.datumMeeverzekeringGezinsleden[gezinsLid - 1].datum,
        DateFormatEnum.Date
      )
    );
  }
  return null;
};

export class BerekenVerdragsbijdrageMapper {
  map = (values: VBRekenModel) => {
    const request: VerdragsbijdrageInputModel = new VerdragsbijdrageInputModel();

    request.ingangsDatum = getDateInUtc(
      formatStringToDate(values.ingangsDatumSection.ingangsDatum, DateFormatEnum.Date)
    );
    request.woonland = values.uwWoonlandSection.uwWoonland;
    request.geboorteDatumVerzekerde = getDateInUtc(
      formatStringToDate(values.geboortedatumSection.geboortedatum, DateFormatEnum.Date)
    );

    const overigeVerzekerden = new OverigeVerzekerdenModel();
    if (values.heeftUPartnerSection?.partner === JaNee.ja) {
      overigeVerzekerden.geboorteDatumPartner = values.geboortedatumPartnerSection?.geboortedatumParner
        ? getDateInUtc(
            formatStringToDate(values.geboortedatumPartnerSection?.geboortedatumParner, DateFormatEnum.Date)
          )
        : null;

      overigeVerzekerden.ingangsDatumPartner = values.partnerMeeverzekerenSection
        ?.partnerVanafWelkeDatumMeeverzekerd
        ? getDateInUtc(
            formatStringToDate(
              values.partnerMeeverzekerenSection?.partnerVanafWelkeDatumMeeverzekerd,
              DateFormatEnum.Date
            )
          )
        : null;
    }

    if (values.gezinsledenMeeverzekerdSection?.gezinsledenMeeverzekerd === JaNee.ja) {
      overigeVerzekerden.ingangsDatumGezinslid1 = gezinsLid(values, 1);
      overigeVerzekerden.ingangsDatumGezinslid2 = gezinsLid(values, 2);
      overigeVerzekerden.ingangsDatumGezinslid3 = gezinsLid(values, 3);
      overigeVerzekerden.ingangsDatumGezinslid4 = gezinsLid(values, 4);
    }
    request.overigeVerzekerden = overigeVerzekerden;

    const wettelijkPensioenOfUitkering = new WettelijkPensioenOfUitkeringModel();

    wettelijkPensioenOfUitkering.type = values.wettelijkPensoenUitkeringSection.soortPensioenOfUitkering;
    wettelijkPensioenOfUitkering.bedrag = stringToFloat(
      values.wettelijkPensoenUitkeringSection.brutoMaandbedrag
    );
    wettelijkPensioenOfUitkering.ingangsDatum = getDateInUtc(
      formatStringToDate(
        values.wettelijkPensoenUitkeringSection.ingangsdatumPensioenOfUitkering,
        DateFormatEnum.Date
      )
    );

    request.wettelijkPensioenOfUitkering = wettelijkPensioenOfUitkering;

    const overigInkomen = new OverigInkomenModel();

    overigInkomen.bedrag = stringToFloat(values.overigInkomenSection.brutoMaandbedrag);
    overigInkomen.ingangsDatum = values.overigInkomenSection.ingangsdatum
      ? getDateInUtc(formatStringToDate(values.overigInkomenSection.ingangsdatum, DateFormatEnum.Date))
      : null;
    request.overigInkomen = overigInkomen;

    if (values.wettelijkPensoenUitkeringSection.soortPensioenOfUitkering === "AOW") {
      request.ouderenKorting = values.ouderenkortingSection.ouderenkorting === JaNee.ja;
      request.alleenstaandeKorting =
        values.alleenstaandeOuderenkortingSection.alleenstaandeOuderenkorting === JaNee.ja;
    } else {
      request.ouderenKorting = false;
      request.alleenstaandeKorting = false;
    }

    request.nietVerdienendePartnerKorting =
      values.heffingskortingSection?.nietVerdienendePartnerKorting === JaNee.ja;

    return request;
  };
}
